import(/* webpackMode: "eager" */ "/app/app/[locale]/(intro)/page.tsx");
